// src/components/layout/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
// import { FiExternalLink } from 'react-icons/fi';
// import HireDropdown from '../Hire/HireDropdown';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  // const [showHireDropdown, setShowHireDropdown] = useState(false);
  const location = useLocation();

  // When clicking the logo, force a full page reload to the main page.
  // If already on the main page, reload the page. Otherwise navigate to '/' via a full load.
  const handleLogoClick = (e) => {
    // prevent the default SPA Link navigation and perform a full page load
    e.preventDefault();
    // Always navigate to the landing page with a query flag so the landing
    // page can detect the navigation and scroll to the hero section.
    try { sessionStorage.setItem('fromLogo', '1'); } catch (err) { /* ignore */ }
    window.location.href = '/?fromLogo=1';
  };

  // Force full page navigation for nav links so pages load from their top sections
  const handleNavClick = (e, path) => {
    e.preventDefault();
    try { sessionStorage.setItem('fromNav', '1'); } catch (err) { /* ignore */ }
    window.location.href = `${path}?fromNav=1`;
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    // setShowHireDropdown(false);
  }, [location]);

  return (
    <motion.header 
      className={`nav header ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        <div className="header-inner">
  <Link to="/" className="logo" onClick={handleLogoClick}>
          <motion.div 
            className="logo-text font-sans"
            whileHover={{ scale: 1.05 }}
          >
            <img  
              className="logo-text-img"
              src={scrolled ? "images/ByteOnTextLogo.png" : "images/ByteOnText.png"} 
              alt="ByteOn Logo"
            />
          </motion.div>
          </Link>

          <div className={`nav-container ${isOpen ? 'open' : ''}`}>
            <nav className="nav">
              <Link to="/" onClick={(e) => handleNavClick(e, '/')} className={location.pathname === '/' ? 'active' : ''}>Home</Link>
              <Link to="/about" onClick={(e) => handleNavClick(e, '/about')} className={location.pathname === '/about' ? 'active' : ''}>About</Link>
              <Link to="/services" onClick={(e) => handleNavClick(e, '/services')} className={location.pathname === '/services' ? 'active' : ''}>Services</Link>
              <Link to="/solutions" onClick={(e) => handleNavClick(e, '/solutions')} className={location.pathname === '/solutions' ? 'active' : ''}>Solutions</Link>
              {/* <Link to="/projects" className={location.pathname === '/projects' ? 'active' : ''}>Projects</Link> */}
              <Link to="/contact" onClick={(e) => handleNavClick(e, '/contact')} className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link>
              
              {/* Hire button code */}
              {/* <div className="relative inline-block"> */}
                {/* <button
                  className="text-hire hover:text-white transition px-4 py-2 font-medium flex items-center gap-1"
                  onClick={() => setShowHireDropdown((prev) => !prev)}
                >
                  Hire <FiExternalLink />
                </button> */}
                {/* {showHireDropdown && <HireDropdown />} */}
              {/* </div> */}


            </nav>
          </div>

          <div 
            className={`menu ${isOpen ? 'open' : ''}`} 
            onClick={() => setIsOpen(!isOpen)}
          >
            {/* <span></span> */}
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
